import { render, staticRenderFns } from "./radsys2.vue?vue&type=template&id=173c747c&scoped=true"
import script from "./radsys2.vue?vue&type=script&lang=js"
export * from "./radsys2.vue?vue&type=script&lang=js"
import style0 from "./radsys2.vue?vue&type=style&index=0&id=173c747c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c747c",
  null
  
)

export default component.exports